export interface ApiErrorData {
  code: string;
  message: string;
}

export interface ErrorResponse {
  status: number;
  data: ApiErrorData;
}

export const ERROR_CODES = {
  EXPIRED_TOKEN: "expired_token",
} as const;

export type ErrorCode = keyof typeof ERROR_CODES;
